module.exports = __webpack_public_path__ + "media/tile-4-image.dba63d1c.webp";